import React, { useEffect, useState } from 'react'
import { requestAPI } from '../../data/api'
import Input from '../../generic/Input'

export default function MappingInput(props) {
	const { metadataField: metadataFieldInitialValue, imageProperty, clientId } = props
	const [ metadataField, setMetadataField ] = useState('')

	useEffect(()=>{
		if(metadataFieldInitialValue)
			setMetadataField(metadataFieldInitialValue)
	}, [metadataFieldInitialValue])

	const saveMapping = () => {
		const mappings = [{
			client_id: clientId,
			image_property: imageProperty,
			metadata_field: metadataField,
		}]
		requestAPI('/metadata-mappings', 'PUT', { clientId, mappings })
	}
	return <Input type='text'
		value={metadataField}
		onChange={e => setMetadataField(e.target.value)}
		onBlur={saveMapping}
	/>
}
